import AddIcon from '@atlaskit/icon/core/migration/add';
import ArrowRightIcon from '@atlaskit/icon/core/migration/arrow-right';
import OpenIcon from '@atlaskit/icon/core/migration/arrow-up-right--open';
import CopyIcon from '@atlaskit/icon/core/migration/copy';
import ActivityIcon from '@atlaskit/icon/core/migration/dashboard--activity';
import EditIcon from '@atlaskit/icon/core/migration/edit';
import DocumentIcon from '@atlaskit/icon/core/migration/file--document';
import FolderIcon from '@atlaskit/icon/core/migration/folder-closed--folder';
import NotificationDirectIcon from '@atlaskit/icon/core/migration/notification--notification-direct';
import PageIcon from '@atlaskit/icon/core/migration/page';
import UserAvatarCircleIcon from '@atlaskit/icon/core/migration/person-avatar--user-avatar-circle';
import SettingsIcon from '@atlaskit/icon/core/migration/settings';
import UndoIcon from '@atlaskit/icon/core/migration/undo';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FORGE_COMMAND_PALETTE_ICON_MAP: Record<string, React.FC<any> | undefined> = {
	add: AddIcon,
	'arrow-right': ArrowRightIcon,
	copy: CopyIcon,
	open: OpenIcon,
	page: PageIcon,
	edit: EditIcon,
	'user-avatar': UserAvatarCircleIcon,
	activity: ActivityIcon,
	settings: SettingsIcon,
	undo: UndoIcon,
	document: DocumentIcon,
	'notification-direct': NotificationDirectIcon,
	folder: FolderIcon,
};
